<p-button class="p-m-1" label="2016" (click)="cambiaYear('2016')"></p-button>
<p-button class="p-m-1" label="2017" (click)="cambiaYear('2017')"></p-button>
<p-button class="p-m-1" label="2018" (click)="cambiaYear('2018')"></p-button>
<p-button class="p-m-1" label="2019" (click)="cambiaYear('2019')"></p-button>
<p-button class="p-m-1" label="2020" (click)="cambiaYear('2020')"></p-button>
<p-button class="p-m-1" label="2021" (click)="cambiaYear('2021')"></p-button>
<p-button class="p-m-1" label="2022" (click)="cambiaYear('2022')"></p-button>
<p-button class="p-m-1" label="2023" (click)="cambiaYear('2023')"></p-button>
<p-button class="p-m-1" label="2024" (click)="cambiaYear('2024')"></p-button>
<p-button class="p-m-1" label="Acumulado" (click)="cambiaYear('')"></p-button>